import React from 'react'
import UserInfo from './UserInfo'
import ApplyCoupon from './ApplyCoupon'
import ApplyCredit from './ApplyCredit'
import BillingInfo from './BillingInfo'

export const CouponsOnlySection = ({
  coupon,
  applyCoupon,
  couponError,
  isCouponApplying,
  isCheckoutCartLoading
}) => (
  <section className="segment coupons-credits-section">
    <h2 className="segment-title">Coupons</h2>
    <ApplyCoupon
      couponApplied={coupon ? coupon.couponApplied : false}
      couponCode={coupon ? coupon.couponCode : null}
      couponAmount={coupon ? coupon.couponAmount : 0}
      applyCoupon={applyCoupon}
      error={couponError}
      isCouponApplying={isCouponApplying}
      isCheckoutCartLoading={isCheckoutCartLoading}
    />
  </section>
)

export const AddCouponBeforeCredits = () => (
  <div className="row center-xs">
    <div className="col-xs-12 pb-1">
      If you'd like to apply a coupon, please do so before applying credits.
    </div>
  </div>
)

export const CouponsAndCreditsSection = ({
  coupon,
  applyCoupon,
  couponError,
  isCouponApplying,
  credit,
  creditError,
  applyCredit,
  suggestedCredits,
  isCreditApplying,
  checkoutCart,
  isCheckoutCartLoading,
  availableCredits,
  isAvailableCreditsLoading
}) => (
  <section className="segment coupons-credits-section">
    <h2 className="segment-title">Coupons &amp; credits</h2>
    {coupon &&
    coupon.couponApplied === false &&
    (credit && credit.creditsApplied === true) ? (
      <AddCouponBeforeCredits />
    ) : (
      <ApplyCoupon
        couponApplied={coupon ? coupon.couponApplied : false}
        couponCode={coupon ? coupon.couponCode : null}
        couponAmount={coupon ? coupon.couponAmount : 0}
        applyCoupon={applyCoupon}
        error={couponError}
        isCouponApplying={isCouponApplying}
        isCheckoutCartLoading={isCheckoutCartLoading}
      />
    )}
    {checkoutCart.orderTotal > 0 || credit.creditsApplied === true ? (
      <ApplyCredit
        creditsApplied={credit ? credit.creditsApplied : false}
        creditsUsed={credit ? credit.creditBalanceUsed : 0}
        suggestedCredits={suggestedCredits}
        applyCredit={applyCredit}
        isCreditApplying={isCreditApplying}
        error={creditError}
        isCheckoutCartLoading={isCheckoutCartLoading}
        availableCredits={availableCredits}
        isAvailableCreditsLoading={isAvailableCreditsLoading}
      />
    ) : null}
  </section>
)

const CheckoutForm = ({
  applyCoupon,
  applyCredit,
  availableCredits,
  checkoutCart,
  checkoutError,
  coupon,
  couponError,
  credit,
  creditCards,
  creditCardsError,
  creditError,
  currentUser,
  firstName,
  handleSubmit,
  isAvailableCreditsLoading,
  isCheckoutCartLoading,
  isCouponApplying,
  isCreditApplying,
  lastName,
  phone,
  selectedCreditCard,
  suggestedCredits,
  user
}) => (
  <form onSubmit={handleSubmit}>
    <section className="segment user-section">
      <h2 className="segment-title">Customer Information</h2>
      <UserInfo
        user={{
          ...user,
          firstName,
          lastName,
          phone
        }}
        currentUser={currentUser}
      />
    </section>
    <section className="segment coupons-credits-section">
      {checkoutCart.orderItems &&
        checkoutCart.orderItems.length > 0 &&
        (!credit || credit.creditBalance === 0 ? (
          <CouponsOnlySection
            coupon={coupon}
            applyCoupon={applyCoupon}
            couponError={couponError}
            isCouponApplying={isCouponApplying}
            isCheckoutCartLoading={isCheckoutCartLoading}
          />
        ) : (
          <CouponsAndCreditsSection
            coupon={coupon}
            applyCoupon={applyCoupon}
            couponError={couponError}
            credit={credit}
            creditError={creditError}
            applyCredit={applyCredit}
            availableCredits={availableCredits}
            isAvailableCreditsLoading={isAvailableCreditsLoading}
            checkoutCart={checkoutCart}
            isCheckoutCartLoading={isCheckoutCartLoading}
            suggestedCredits={suggestedCredits}
            isCreditApplying={isCreditApplying}
            isCouponApplying={isCouponApplying}
          />
        ))}
    </section>
    <section className="segment billing-section">
      {checkoutCart && checkoutCart.orderTotal === 0 ? (
        <h2 className="segment-title">Your meal is covered!</h2>
      ) : (
        [
          <h2 key="title" className="segment-title">
            Billing Information
          </h2>,
          <BillingInfo
            key="billing-form"
            creditCards={creditCards}
            creditCardsError={creditCardsError}
            selectedCreditCard={selectedCreditCard}
          />
        ]
      )}
      {checkoutError && (
        <div className="primary">
          <p>{checkoutError.message}</p>
        </div>
      )}
    </section>
  </form>
)

CheckoutForm.defaultProps = {
  user: {}
}
export default CheckoutForm
